class CartSaveInline extends HTMLElement {
  connectedCallback() {
    this._trigger = this.querySelector('[data-trigger]');
    this._form = this.querySelector('[data-form]');
    this._emailInput = this.querySelector('.cart-save-inline__email');
    this._savedRow = this.querySelector('[data-saved]');
    this._savedEmailEl = this.querySelector('[data-saved-email]');
    this._undoBtn = this.querySelector('[data-undo]');

    this._trigger?.addEventListener('click', () => this._toggle());
    this._form?.addEventListener('submit', (e) => { e.preventDefault(); this._submit(); });
    this._undoBtn?.addEventListener('click', () => this._undo());
  }

  _toggle() {
    const isOpen = this.dataset.state === 'open';
    this.dataset.state = isOpen ? 'collapsed' : 'open';
    this._trigger?.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (!isOpen) this._emailInput?.focus();
  }

  _submit() {
    const email = this._emailInput?.value?.trim();
    if (!email || !this._emailInput.validity.valid) {
      this._emailInput?.reportValidity();
      return;
    }
    if (this._savedEmailEl) this._savedEmailEl.textContent = email;
    this.dataset.state = 'saved';

    this.dispatchEvent(new CustomEvent('cart-save:submit', {
      bubbles: true,
      detail: { email },
    }));
  }

  _undo() {
    if (this._emailInput) this._emailInput.value = '';
    this.dataset.state = 'collapsed';
    this._trigger?.setAttribute('aria-expanded', 'false');

    this.dispatchEvent(new CustomEvent('cart-save:undo', { bubbles: true }));
  }
}

customElements.define('cart-save-inline', CartSaveInline);
